import React, { useState } from 'react';
import tabBunnies from '~/images/tabs-left-bunnies.svg';
import ImageModal from '../../wrappers/image-modal';
import BunnyImage from '../../wrappers/bunny-image';

interface TabsProps<T> {
  tabsData: {
    theme: string;
    show_bunnies_image: boolean;
    header_col: string;
    data_col: string;
    tab_list: T[];
  };
}

const TabsLeft: React.FC<TabsProps<DetailedTabItem>> = ({ tabsData }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const headerCol = tabsData.header_col ? tabsData.header_col : 'col-lg-5';
  const dataCol = tabsData.data_col ? tabsData.data_col : 'col-lg-7';
  const theme = `tabs-header--${tabsData.theme || 'light'}`;

  const toggleTabs = (index: number) => () => {
    if (index !== activeIndex) {
      setActiveIndex(index);
    }
  };

  return (
    <>
      {tabsData.show_bunnies_image && (
        <img
          className='bunnies'
          src={tabBunnies}
          alt='bunny.net'
          title='bunny.net'
          loading='lazy'
        />
      )}
      <div className='row'>
        <div className={`${headerCol} is-desktop`}>
          <ul className={`tabs-header ${theme}`}>
            {tabsData.tab_list.map((tab, index) => {
              return (
                <li
                  key={index}
                  className={`tab-title ${activeIndex === index ? 'is-active' : ''}`}
                  onClick={toggleTabs(index)}
                  id={`${index}`}
                >
                  {tab.tab_icon && (
                    <div className='image'>
                      <img
                        src={tab.tab_icon}
                        alt={tab.tab_title}
                        title={tab.tab_title}
                        loading='lazy'
                      />
                    </div>
                  )}
                  {tab.tab_title && tab.tab_title}
                </li>
              );
            })}
          </ul>
        </div>
        <div className={`${dataCol}`}>
          <div className='tabs-wr'>
            {tabsData.tab_list.map((tab, index) => {
              return (
                <div
                  key={index}
                  className={`tab-content ${activeIndex === index ? 'is-active' : ''}`}
                >
                  {tab.tab_title && (
                    <h3 className='is-mobile'>{tab.tab_title}</h3>
                  )}
                  {tab.image && (
                    <ImageModal>
                      <BunnyImage
                        src={tab.image}
                        alt={tab.image_alt_text}
                        width={640}
                        height={320}
                      />
                    </ImageModal>
                  )}
                  {tab.html && (
                    <div
                      className='video-wr'
                      dangerouslySetInnerHTML={{ __html: tab.html }}
                    ></div>
                  )}
                  {tab.title && (
                    <h4 dangerouslySetInnerHTML={{ __html: tab.title }}></h4>
                  )}
                  {tab.text && (
                    <div
                      className='text-formatted'
                      dangerouslySetInnerHTML={{ __html: tab.text }}
                    ></div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default TabsLeft;
